// removed by extract-text-webpack-plugin
module.exports = {"avatar":"ContactCard__avatar___2MvLJ","contactcard":"ContactCard__contactcard___2-yHT","activity":"ContactCard__activity___17YMW","textblock":"ContactCard__textblock___2qXLt","position":"ContactCard__position___IvofU","inline":"ContactCard__inline___1VC5l","inlineImg":"ContactCard__inlineImg___rjpbp","tooltip":"ContactCard__tooltip___3lgO4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactCard/ContactCard.scss
// module id = 1171
// module chunks = 1